import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Form, FormDate, FormInput } from '../../core/Formikfy';
import { Card } from '../Card/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  formInput: {
    margin: '10px',
  },
  contentHeading: {
    textAlign: 'left',
    fontSize: '1rem',
    fontWeight: 700,
    color: '#3C4858',
  },
  contentSubHeading: {
    textAlign: 'left',
    textTransform: 'uppercase',
    marginBottom: '20px',
    fontSize: '0.75rem',
    fontWeight: 400,
    color: '#999',
  },
}));

export const Experience = (props) => {
  const classes = useStyles();
  const { isPublicView, deleteExperience, tileId } = props;
  const [tileIndex, setTileIndex] = useState(0);
  const [qualificationInfoOpen, setQualificationInfoOpen] = React.useState(false);

  const qualificationInfoHandleOpen = () => {
    setQualificationInfoOpen(true);
  };
  const qualificationInfoHandleClose = () => {
    setQualificationInfoOpen(false);
  };
  useEffect(() => {
    setTileIndex(tileId);
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      {props.index !== 0 && <Divider variant="middle" style={{ marginBottom: '20px' }} />}
      <Grid container>
        <Grid item xs={10}>
          <Typography variant="h6" className={classes.contentHeading}>
            {props.item.place}
          </Typography>
          <Typography variant="h6" className={classes.contentSubHeading}>
            {props.item.position}
          </Typography>
        </Grid>
        {!isPublicView && (
          <Grid item xs={2}>
            <IconButton color="default" onClick={qualificationInfoHandleOpen}>
              <EditIcon />
            </IconButton>
          </Grid>
        )}
        <Dialog open={qualificationInfoOpen} onClose={qualificationInfoHandleClose}>
          <DialogTitle id={props.item.title}>Update Qualification</DialogTitle>
          <Form
            className={classes.form}
            initialValues={{
              place: props.item.place,
              position: props.item.position,
              // to: new Date(props.item.yearTo.seconds * 1000).toDateString(),
            }}
            onSubmit={(data) => {
              const newData = { place: data.place, position: data.position };
              props.experienceUpdate(tileIndex, newData);
              qualificationInfoHandleClose();
            }}
          >
            <DialogContent>
              <DialogContentText>
                Enter your experience to display them in your Profile
              </DialogContentText>

              <div>
                <Card elevation={3} style={{ marginTop: '20px' }}>
                  <CardContent>
                    <FormInput
                      type="text"
                      label="Function"
                      name="place"
                      variant="standard"
                      fullWidth={true}
                    />
                    <FormInput
                      type="text"
                      label="Position"
                      name="position"
                      variant="standard"
                      fullWidth={true}
                    />
                  </CardContent>
                </Card>
              </div>
            </DialogContent>
            <DialogActions style={{ display: 'block' }}>
              <Button
                onClick={qualificationInfoHandleClose}
                color="primary"
                style={{ marginLeft: '10px' }}
              >
                Cancel
              </Button>
              <Button type="submit" color="primary" style={{ marginRight: '10px', float: 'right' }}>
                Update
              </Button>
              <IconButton
                style={{ right: '0', top: '0', position: 'absolute' }}
                color="primary"
                onClick={() => deleteExperience(tileIndex)}
              >
                <DeleteIcon />
              </IconButton>
            </DialogActions>
          </Form>
        </Dialog>
      </Grid>
    </div>
  );
};
